const languageSelect = document.getElementById('language-choice');

const myAccount = document.getElementById('my-account');

// toggle language options nav
if(languageSelect) {
    let languageContent = languageSelect.nextElementSibling;
    languageSelect.addEventListener('click', function(e) {
        //e.preventDefault();
        this.classList.toggle('active');
        languageContent.classList.toggle('active');
        if (languageContent.style.display === "none") {
            languageContent.style.display = "block";
        } else {
            languageContent.style.display = "none";
        }

    });
}

// toggle account options nav
if(myAccount) {
    let accountContent = myAccount.nextElementSibling;
    myAccount.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('active');
        accountContent.classList.toggle('active');
    });
}

const mobileMenuBtn = document.querySelector('.btn--mobile-menu');
// toggle mobile nav
if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener("click", toggleMenu);
}

function toggleMenu() {
    toggleBars();
    const mobileMainMenu = document.querySelector('.header__main-nav-content');
    mobileMainMenu.classList.toggle('active');
    const body = document.getElementsByTagName("body")[0];
    body.classList.toggle('active');
    // body.addEventListener('touchmove', function(e) {
    //     e.preventDefault();
    // }, false);
}

function toggleBars() {
    const barOne = document.getElementById("bar");
    barOne.classList.toggle("active");
    const barTwo = document.getElementById("bar2");
    barTwo.classList.toggle("active");
    const barThree = document.getElementById("bar3");
    barThree.classList.toggle("active");
}

const secondaryFlyoutMenu = document.querySelectorAll('.header__primary-nav-item');
const flyoutMenuContent = document.querySelectorAll('.header__dropdown-menu');
const closeFlyoutMenus = document.querySelectorAll('.return-btn');
const menuOverlay = document.querySelector('.nav-overlay');

let viewportWidth;

let setViewportWidth = function () {
    viewportWidth = window.innerWidth || document.documentElement.clientWidth;
};


const clickHandler = function(event) {
    event.preventDefault();
};
const anotherHandler = function(e) {
    event.returnValue = true;
    window.location = e.target.href;
};
let logWidth = function () {

    if (viewportWidth < 992) {
        // Show secondary level flyouts
        if(secondaryFlyoutMenu.length > 0) {
            secondaryFlyoutMenu.forEach(function(menu, index) {
                
                const aTag = menu.firstElementChild;

                aTag.removeEventListener('click', anotherHandler, false);
                aTag.addEventListener('click', function(event) {
                    clickHandler(event);
                    let menuIndex = Array.from(menu.parentNode.children).indexOf(menu);
                    flyoutMenuContent[menuIndex].classList.add('active');
                    
                }) ;
            });
        }

        // Close secondary level flyouts
        if(closeFlyoutMenus.length > 0) {
            closeFlyoutMenus.forEach(function(panel, index) {
                panel.addEventListener('click', function(e) {
                    e.stopPropagation();
                    flyoutMenuContent.forEach(function (item) {
                        item.classList.remove('active');
                    });

                });
            });
        }
    }

    if (viewportWidth > 992) {
        
        const mobileMainMenu = document.querySelector('.header__main-nav-content');
        const barOne = document.getElementById("bar");
        const barTwo = document.getElementById("bar2");
        const barThree = document.getElementById("bar3");
        const mobileSearchClose = document.querySelector('.header__search');
        if(mobileMainMenu) {
            mobileMainMenu.classList.remove('active');
            barOne.classList.remove("active");
            barTwo.classList.remove("active");
            barThree.classList.remove("active");
            //mobileSearchClose.classList.remove('active');
            
            secondaryFlyoutMenu.forEach(function(activateLink, index) {
                const aTag = activateLink.firstElementChild;
                
                aTag.removeEventListener('click', clickHandler, false);
               aTag.addEventListener('click', anotherHandler, false);
                
            });

            secondaryFlyoutMenu.forEach(function(dropDown, index) {
                
                dropDown.addEventListener('mouseover', function() {

                    let menuIndex = Array.from(dropDown.parentNode.children).indexOf(dropDown);

                    flyoutMenuContent[menuIndex].classList.add('active-dropdown');

                    if (flyoutMenuContent[menuIndex].classList.contains('active-dropdown')) {
                        menuOverlay.classList.add('active');
                    }
                    
                });
            });

            secondaryFlyoutMenu.forEach(function(dropDown, index) {
                
                dropDown.addEventListener('mouseleave', function() {

                    let menuIndex = Array.from(dropDown.parentNode.children).indexOf(dropDown);

                    flyoutMenuContent[menuIndex].classList.remove('active-dropdown');

                    menuOverlay.classList.remove('active');
                
                });
            });
        }
    }

    const mobileFlyoutTriggerLink = document.querySelectorAll('.flyout-trigger-link');
    const mobileFlyoutTrigger = document.querySelectorAll('.mobile-secondary-nav_item');
    const mobileFlyoutMenu = document.querySelectorAll('.mobile-secondary-nav__dropdown-menu');
    const mobileSearchBtn = document.querySelector('.btn--mobile-search');
    const mobileSearchContent = document.querySelector('.header__search');
    const closeMobileSearchBtn = document.querySelector('.header__search-mobile-btn');

    if(mobileSearchBtn) {
        mobileSearchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            mobileSearchContent.classList.toggle('active');
        });
    }

    if(closeMobileSearchBtn) {
        closeMobileSearchBtn.addEventListener('click', function(e) {
            mobileSearchContent.classList.remove('active');
        });
    }
    
    
    if (viewportWidth < 992) {

        if (mobileFlyoutTrigger.length > 0) {
        
            mobileFlyoutTriggerLink.forEach(function (navLink, index) {
                navLink.addEventListener('click', function (e) {
                    //e.preventDefault();
                });
            });
            // Get index of nav list items with a specific class
            mobileFlyoutTrigger.forEach(function (navTrigger, index) {
                navTrigger.addEventListener('click', function (e) {
                    const clickedTrigger = this;
                    let triggerIndex = Array.from(mobileFlyoutTrigger).indexOf(clickedTrigger);
                    const activeFlyoutMenu = mobileFlyoutMenu[triggerIndex];

                    if (!activeFlyoutMenu.classList.contains('active')) {
                        mobileFlyoutMenu.forEach(function (menuItem) {
                            menuItem.classList.remove('active');
                            activeFlyoutMenu.classList.add('active');
                        });
                    }
                });
            });
        }
        // Close secondary mobile level flyouts
        const closeFlyoutMenus = document.querySelectorAll('.return-btn');
        if(closeFlyoutMenus.length > 0) {
            closeFlyoutMenus.forEach(function (returnBtn) {
                returnBtn.addEventListener('click', function () {
                    const allFlyoutMenus = document.querySelectorAll('.mobile-secondary-nav__dropdown-menu');
                    allFlyoutMenus.forEach(function (singleFlyout, index) {
                        singleFlyout.classList.remove('active');
                    });

                });
            });
        }
        
    }
};

// Set our initial width and log it
setViewportWidth();
logWidth();

// // On resize events, recalculate and log
window.addEventListener('resize', function () {
    setViewportWidth();
    logWidth();
}, false);
